import { IPaginator } from 'models/paginator';

export enum EDictionaryTypes {
  Country = 'country',
  Caliber = 'frt_caliber',
  Manufacturer = 'frt_manufacturer',
  FirearmAction = 'firearm_action',
  FirearmType = 'firearm_type',
  Region = 'region',
  Gender = 'gender',
  OrganisationCivilianType = 'organisation_civilian_type',
  OrganisationStateType = 'organisation_state_type',
  OrganisationMilitaryType = 'organisation_military_type',
  OrganisationPoliceType = 'organisation_police_type',
  OrganisationCategory = 'organisation_legal_entity_group',
  LegalVisibility = 'legal_visibility',
  legalEntityPrefix = 'individual_legal_entity_group',
  civilianPrefix = 'civilian_prefix',
  militaryPrefix = 'military_prefix',
  policePrefix = 'police_prefix',
  PhoneCode = 'phone_code',
  Legality = 'legality',
  Make = 'frt_make',
  Model = 'frt_model',
  State = 'firearm_state',
  BarrelType = 'frt_barrel_type',
  Level = 'frt_level',
  AddressType = 'address_type',
  TransactionType = 'transaction_type',
  ManufacturerCountry = 'manufacturer_country',
  LegalClassification = 'frt_legal_classification',
  Activity = 'activity',
  CountryAll = 'country_all',
  ArtAccessoryCalibre = 'art_accessory_calibre',
  ArtaccessoryComposition = 'art_composition',
  ArtAccessoryHostType = 'art_accessory_host_type',
  ArtAccessoryLightColour = 'art_accessory_light_colour',
  ArtAccessoryMagnification = 'art_accessory_magnification',
  ArtAccessoryManufacturerFlashEliminator = 'art_accessory_manufacturer_flash_eliminator',
  ArtAccessoryManufacturerLaserLightModule = 'art_accessory_manufacturer_laser_light_module',
  ArtAccessoryManufacturerMagazine = 'art_accessory_manufacturer_magazine',
  ArtAccessoryManufacturerOpticalSight = 'art_accessory_manufacturer_optical_sight',
  ArtAccessoryManufacturerSuppressor = 'art_accessory_manufacturer_suppressor',
  ArtAccessoryReticle = 'art_accessory_reticle',
  ArtAccessoryType = 'art_accessory_type',
  ArtAccessoryUtility = 'art_accessory_utility',
  ArtAccessoryProofHouse = 'art_accessory_proof_house',
  ArtAncillaryOptions = 'art_ancillary_type',
  nationality = 'nationality',
  legalType = 'legal_type',

  currency = 'currency',
  measurementUnit = 'measurement_unit',

  ArtAmmunitionType = 'art_ammunition_type',
  ArtAmmunitionManufacturer = 'art_ammunition_manufacturer',
  ArtAmmunitionFactory = 'art_ammunition_factory',
  ArtAmmunitionCalibreGauge = 'art_ammunition_calibre_gauge',
  ArtAmmunitionCartridgeComposition = 'art_ammunition_cartridge_composition',
  ArtAmmunitionColourOfPrimerSealant = 'art_ammunition_colour_of_primer_sealant',
  ArtAmmunitionProjectileShape = 'art_ammunition_projectile_shape',
  ArtAmmunitionFunctionalType = 'art_ammunition_functional_type',
  ArtAmmunitionShotSize = 'art_ammunition_shot_size',
  ArtAmmunitionMunitionType = 'art_ammunition_munition_type',
  ArtAmmunitionMunitionVelocity = 'art_ammunition_munition_velocity',

  ArtComponentType = 'art_component_type',
  ArtComponentManufacturer = 'art_component_manufacturer',
  ArtComponentCalibre = 'art_component_calibre',
  ArtComponentCapacity = 'art_component_capacity',
  ArtComponentProofHouse = 'art_component_proof_house',
  ArtComposition = 'art_composition',

  AuditLogModule = 'module',
  AuditLogEventType = 'auditlog_event_type',
  AuditLogEventName = 'auditlog_event_name',

  ApiKeyType = 'apikey_type',

  IdentificationDocumentType = 'identification_document_type',
  attachmentDocumentTypeData = 'attachment_document_type',
  MaritalStatus = 'marital_status',

  task = 'task',
  weaponLicenceRegion = 'weapon_licence_region',
  weaponLicenceCategory = 'weapon_licence_category',
  weaponLicencePrimaryPurpose = 'weapon_licence_primary_purpose',
  weaponLicenceCondition = 'weapon_licence_condition',
  weaponLicenceCompetency = 'weapon_licence_competency',
  weaponLicenceLimit = 'weapon_licence_duration',
  weaponLicenceDuration = 'weapon_licence_duration',
  weaponLicenceFee = 'weapon_licence_fee',
  weaponLicencingAuthority = 'weapon_licencing_authority',
  weaponLicenceGoodReason = 'weapon_licence_good_reason',
  weaponLicencePaymentStatus = 'weapon_licence_payment_status',
  weaponLicenceStatus = 'weapon_licence_status',
  weaponLicenceHistoryAction = 'weapon_licence_history_action',
  applicationProcessTypes = 'application_process_type',
  caseProcessTypes = 'case_process_type',
  applicationProcessStatus = 'application_process_status',
  legalStatus = 'legal_status',
  legalIndividualDeactivationReason = 'legal_individual_deactivation_reason',
  legalOrganisationDeactivationReason = 'legal_organisation_deactivation_reason',
  weaponLicenceTemplateStatus = 'weapon_licence_template_status',
  weaponLicenceCaseStatus = 'weapon_licence_case_status',
  weaponLicencePrintStatus = 'weapon_licence_print_status',
  weaponLicencePrintBatchStatus = 'weapon_licence_print_batch_status',
  weaponLicencePrintType = 'weapon_licence_print_type',
  taskStatus = 'task_status',
  intelligenceReportSourceSystem = 'intelligence_report_source_system',
  caseRejectionReason = 'case_rejection_reason',
  caseApprovalReason = 'case_approval_reason',
  caseRefusalReason = 'case_refusal_reason',
  otherRequestTaskName = 'other_request_task_name',
}

export interface ITranslation {
  uniqueId: string;
  languageUniqueId: string;
  name: string;
  code: string;
}

export interface IDictionary {
  uniqueId: string | number;
  type: string;
  name: string;
  isActive?: string | boolean;
  managedByAdmin?: boolean;
  translatedValues?: boolean;
  translations?: ITranslation[];
  valuesDeactivation?: boolean;
}

export interface IDictionaryResponse {
  content: IDictionary[];
}
export interface IAsyncDictionaryResponse {
  content: IDictionary[];
  totalElements: number;
}

export interface IDictionaryContentValues {
  uniqueId: string | number;
  name: string;
  isActive: boolean;
  edit?: boolean;
}

export interface IDictionaryValuesData {
  [key: string]: string;
}

export interface IDictionaryValueFormValues {
  isActive: string | boolean;
  translations: IDictionaryValuesData;
}

export interface IDictionaryValueForm {
  initialFormValues: IDictionaryValueFormValues;
  type: EDictionaryTypes | undefined;
  dictionaryLanguages: IDictionaryLanguage[];
  managedByAdmin: boolean;
  translatedValues: boolean;
  valuesDeactivation: boolean;
  onCancel?: () => void;
  onSubmit: (arg: IDictionaryValueFormValues) => void;
  isEdit?: boolean;
  hasOnlyEnglishTranslations?: boolean;
}

export interface IDictionaryTab {
  name: string;
  description: string;
  managedByAdmin: boolean;
  translateName: string;
  translatedValues: boolean;
  newValues: boolean;
  valuesDeactivation: boolean;
  englishValuesNamesUpdate: boolean;
}

export interface IDictionaryValues extends IPaginator {
  content: IDictionaryContentValues[];
}

export interface IDictionaryDetailResponse {
  values?: IDictionaryValues;
  managedByAdmin: boolean;
  translatedType: string;
  type: string;
  translatedDescription: string;
  translatedValues: string;
  newValues: string;
  valuesDeactivation: boolean;
  englishValuesNamesUpdate: string;
}

export interface IDictionaryLanguage {
  uniqueId: string;
  code: string;
  defaultLanguage: boolean;
  name: string;
}

export interface IDictionarySearchLike {
  searchValue: string;
}

export interface IDictionariesResponse extends IPaginator {
  content: IDictionaryTab[];
}

export enum ETransactionDictionaryItemTypes {
  COMPONENT = 'COMPONENT',
  FIREARM = 'FIREARM',
  AMMUNITION = 'AMMUNITION',
  ACCESSORY = 'ACCESSORY',
}

export enum EDictionaryPrefixTypes {
  civilianPrefix = 'civilian_prefix',
  militaryPrefix = 'military_prefix',
  policePrefix = 'police_prefix',
}

export enum EManagedByAdminAndNoTranslationsDictionaries {
  phone_code = 'phone_code',
  make = 'make',
  frt_manufacturer = 'frt_manufacturer',
  manufacturer = 'manufacturer',
  firearm_action = 'firearm_action',
  firearm_type = 'firearm_type',
  frt_barrel_type = 'frt_barrel_type',
  barrel_type = 'barrel_type',
  art_accessory_manufacturer_magazine = 'art_accessory_manufacturer_magazine',
  art_accessory_manufacturer_optical_sight = 'art_accessory_manufacturer_optical_sight',
  art_accessory_manufacturer_suppressor = 'art_accessory_manufacturer_suppressor',
  art_accessory_calibre = 'art_accessory_calibre',
  art_accessory_magnification = 'art_accessory_magnification',
  art_ammunition_manufacturer = 'art_ammunition_manufacturer',
  art_ammunition_factory = 'art_ammunition_factory',
  art_ammunition_calibre_gauge = 'art_ammunition_calibre_gauge',
  art_component_manufacturer = 'art_component_manufacturer',
  art_component_calibre = 'art_component_calibre',
  art_component_capacity = 'art_component_capacity',
  art_component_proof_house = 'art_component_proof_house',
  manufacturer_country = 'manufacturer_country',
  model = 'model',
  caliber = 'caliber',
  legal_classification = 'legal_classification',
  level = 'level',
  art_accessory_manufacturer_flash_eliminator = 'art_accessory_manufacturer_flash_eliminator',
  art_accessory_manufacturer_laser_light_module = 'art_accessory_manufacturer_laser_light_module',
  currency = 'currency',
  measurement_unit = 'measurement_unit',
}
